(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-flagship"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.flagshipReady === 'true') return;

      const slides = Array.from(root.querySelectorAll('[data-flagship-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-flagship-dot]'));
      const previous = root.querySelector('[data-flagship-previous]');
      const next = root.querySelector('[data-flagship-next]');

      if (slides.length < 2) return;

      root.dataset.flagshipReady = 'true';
      let current = 0;
      let timer;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (root.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const interval = Number(root.dataset.interval) || 6000;
        timer = window.setInterval(() => show(current + 1), interval);
      };

      previous?.addEventListener('click', () => {
        show(current - 1);
        start();
      });

      next?.addEventListener('click', () => {
        show(current + 1);
        start();
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          show(index);
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      start();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-flagship-carousel]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('[data-flagship-carousel]');
      if (!root) return;
      const slides = Array.from(root.querySelectorAll('[data-flagship-slide]'));
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index < 0) return;
      root.querySelectorAll('[data-flagship-dot]')[index]?.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
